import { PhoneOutlined } from "@ant-design/icons";
import { Avatar, Space } from "antd";
import { Text } from "components/UI";

const ContactMessage = ({ messageText }) => {
  return (
    <Space className="bg-gray-200 p-3 rounded-lg">
      <Avatar className="bg-green-400" icon={<PhoneOutlined />} />
      <Text
        copyable={{
          text: messageText,
          tooltips: true,
          format: "text/plain",
        }}
      >
        {messageText}
      </Text>
    </Space>
  );
};

export default ContactMessage;
